import { render, staticRenderFns } from "./pos-send-ticket-by-email-modal.vue?vue&type=template&id=44124a26&scoped=true&"
import script from "./pos-send-ticket-by-email-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-send-ticket-by-email-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44124a26",
  null
  
)

export default component.exports